import { useEffect, useMemo, useState } from 'react';
import { listMovies, type MovieListItem } from '../api/library';
import { getContinueWatching, type ProgressItem } from '../api/progress';
import { ContinueWatchingRow } from '../components/ContinueWatchingRow';
import { LibraryGrid } from '../components/LibraryGrid';

export function Home() {
  const [movies, setMovies] = useState<MovieListItem[] | null>(null);
  const [progress, setProgress] = useState<ProgressItem[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    Promise.all([listMovies(), getContinueWatching()])
      .then(([m, p]) => {
        if (cancelled) return;
        setMovies(m.items);
        setProgress(p.items);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.message || 'Failed to load library.');
      });
    return () => { cancelled = true; };
  }, []);

  const byId = useMemo(() => {
    const map = new Map<string, MovieListItem>();
    for (const m of movies || []) map.set(m.id, m);
    return map;
  }, [movies]);

  const recentlyAdded = useMemo(() => (movies || []).slice(0, 12), [movies]);

  if (error) return <div className="text-red-600">{error}</div>;
  if (!movies) return <div className="text-text-secondary">Loading…</div>;

  return (
    <div>
      <ContinueWatchingRow progress={progress} byId={byId} />
      <section>
        <h2 className="mb-3 text-lg font-semibold">Recently added</h2>
        <LibraryGrid items={recentlyAdded} />
      </section>
    </div>
  );
}
